import { type FilterValues } from "components/filters/FilterContext";
import { mapFreefieldProfileFilterToInstruction, mapKeywordFilterToInstruction, mapResponseToFreefieldProfileFilter, mapResponseToKeywordFilter, mapResponseToUserToClientLifecycleFilter, mapUserToClientLifecycleToInstruction } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.ListInternalUserInstruction => {
  return {
    keyword: mapKeywordFilterToInstruction(filter.keyword),
    freeFieldProfileIds: mapFreefieldProfileFilterToInstruction(filter.freefieldProfile),
    userToClientLifeCycles: mapUserToClientLifecycleToInstruction(filter.userToClientLifecycle),
    page,
    perPage,
    cache: filterSet
  };
};

export const mapResponseToFilterValues = (
  response: server.dto.ListInternalUserFilters,
  _: FilterValues
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response.keyword),
  freefieldProfile: mapResponseToFreefieldProfileFilter(response.freeFieldProfiles),
  userToClientLifecycle: mapResponseToUserToClientLifecycleFilter(response.userToClientLifeCycles)
});